import {createStore, applyMiddleware} from 'redux' 

import { persistStore } from 'redux-persist'; // (1) import persistStore

// import logger from 'redux-logger' 
import rootReducer from './root-reducer'


const middlewares = [];

export const store = createStore(rootReducer, applyMiddleware(...middlewares))
// (2) make export for the store

export const persistor = persistStore(store) 
// (3) make persistor and make export for it 
